export enum StartNowPaymentType {
  FullPayment = 'FullPayment',
  DepositAmount = 'DepositAmount',
  ReducedDepositAmount = 'ReducedDepositAmount',
}
